import { useNavigate, useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { useActiveAccountOptional } from './useActiveAccount';
import {
  UNPREFIXED_ROOT_SEGMENTS,
  isAccountId,
  stripAccountPrefix,
} from '../constants/permissions';

export function accountPath(path, accountId) {
  if (!path) return accountId ? `/${accountId}` : '/';
  if (/^https?:\/\//i.test(path)) return path;
  const stripped = stripAccountPrefix(path);
  const [, first = ''] = stripped.split('/');
  if (UNPREFIXED_ROOT_SEGMENTS.has(first.toLowerCase())) return stripped;
  if (!accountId) return stripped;
  if (stripped === '/') return `/${accountId}`;
  return `/${accountId}${stripped}`;
}

export default function useAccountNavigate() {
  const navigate = useNavigate();
  const account = useActiveAccountOptional();
  const params = useParams();
  const accountId =
    account?.accountId ||
    (isAccountId(params.accountId) ? params.accountId : null);

  const go = useCallback((to, options) => {
    if (typeof to === 'number') {
      navigate(to);
      return;
    }
    const path = typeof to === 'string' ? to : to?.pathname;
    navigate(accountPath(path, accountId) + (typeof to === 'object' && to.search ? to.search : ''), options);
  }, [navigate, accountId]);

  return { navigate: go, accountPath: (p) => accountPath(p, accountId), accountId };
}
